import { render } from "./Input.vue?vue&type=template&id=3a5057c4&scoped=true"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3a5057c4"

export default script